import { useEffect, useState } from "react";
import { Leaf, Menu, X } from "lucide-react";
import { NAV_LINKS, scrollToId } from "@/data/content";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,padding] duration-500 ${
        scrolled ? "bg-ivory/90 backdrop-blur-xl shadow-[0_1px_0_0_#E2DDD5] py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sage text-ivory">
            <Leaf size={17} strokeWidth={1.8} />
          </span>
          <span className={`font-serif text-lg sm:text-xl font-semibold tracking-tight transition-colors duration-500 ${scrolled ? "text-ink" : "text-ivory"}`}>
            Orto della Longevità
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-7" data-testid="nav-links-desktop">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className={`text-[13px] font-medium tracking-wide transition-colors duration-300 hover:text-terracotta ${
                scrolled ? "text-moss" : "text-ivory/85"
              }`}
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-visit"
            onClick={() => go("contatti")}
            className="rounded-full bg-sage px-5 py-2.5 text-[13px] font-semibold text-ivory transition-all duration-300 hover:bg-sage-dark hover:shadow-lg hover:shadow-sage/25 hover:-translate-y-0.5"
          >
            Prenota una Visita
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className={`lg:hidden rounded-full p-2 transition-colors ${scrolled ? "text-ink" : "text-ivory"}`}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-ivory/97 backdrop-blur-xl border-t border-sand px-6 py-6 flex flex-col gap-4" data-testid="nav-links-mobile">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left font-serif text-xl text-ink hover:text-sage transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-cta-visit"
            onClick={() => go("contatti")}
            className="mt-2 rounded-full bg-sage px-6 py-3 text-sm font-semibold text-ivory"
          >
            Prenota una Visita
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
